import { Stack, Typography } from "@mui/material";
import { useAuth } from "../../auth/context";
import Logo from "./Logo";
import InstallPwaButton from "../../utils/InstallPwaButton";
import NewPatientButton from "./NewPatientButton";
import  NewOrderAndNewPrescription  from "./mainOptions";
import NewFeatureMessage from "../../utils/NewFeatureMessage";
import SearchBar from "./SearchBar";

const Home = () => {
  const { user } = useAuth();

  return (
    <Stack flexDirection="column" justifyContent="space-between" height="100%" width="100%">
      <Stack display="flex" flexDirection="column" justifyContent="center" spacing={5} p="2rem">
        <Logo />
        <Stack>
          <SearchBar />
        </Stack>

        <Stack>
          <Typography variant="h5" sx={{ color: "primary.main" }}>
            Bienvenid{user.title === "Dr" ? "o" : "a"}, <strong>{`${user.name} ${user.surname}`}</strong>
          </Typography>

          <Typography variant="body1" color="text.black" fontSize={16} mt={1}>
            Elegí una opción para comenzar
          </Typography>
        </Stack>

        <Stack direction={{ xs: "column", sm: "row" }}>
          <NewOrderAndNewPrescription />
        </Stack>
        <NewFeatureMessage />
      </Stack>
      <NewPatientButton />
      <InstallPwaButton />
    </Stack>
  );
};

export default Home;
